import React from 'react';
import ReminderMessageBundle from './ReminderMessageBundle'

import '../../App.css';
import '../../bootstrap.css';

export default class ReminderSpecificActivities extends React.Component {
  constructor(props) {
    super(props);
    this.state = {}
  }

  componentDidMount() {
  }

  render() {
    return (
      <div>
        <ul>
          {Object.keys(this.props.specificActivities).map((key) =>
            <div key={key}>
              <li>
                {key}
                <ReminderMessageBundle hourPath={this.props.hourPath} path={this.props.path + '/' + key} messageBundle={this.props.specificActivities[key]}
                  firebase={this.props.firebase} refresh={this.props.refresh} workoutsMap={this.props.workoutsMap}
                  dailyHabitsMap={this.props.dailyHabitsMap} weeklyHabitsMap={this.props.weeklyHabitsMap}
                  hideDisabled={this.props.hideDisabled} ignoreCondition={this.props.ignoreCondition}/>
              </li>
            </div>
          )}
        </ul>
      </div>
    )
  }
}


// WEBPACK FOOTER //
// ./src/main/reminders/ReminderSpecificActivities.js